/* eslint-disable */
import { load, dom } from '../ws-util';
import { browser } from '../ws-hybrid';

/**
 * @class ComUI
 */
class ComUI {
  constructor() {
    this.hasBindMaskCloseEvent = false;
    this.hasBindQRCodeEvent = false;
  }

  /**
   * 显示下载微视二维码
   * @method
   */
  showQRCode() {
    const qrcodeDom = document.querySelector('.j-pop');
    if (!qrcodeDom) {
      const qrcodeDomStr = `
        <div class="mod-dialog j-pop" style="display: none;">
          <div class="dialog-hd">
            <div class="hd-act">
              <a class="dialog-close" href="javascript:;" title="关闭"><i class="icon icon-close j-icon-close"></i></a>
            </div>
          </div>
          <div class="dialog-bd">
            <div class="mod-info">
              <div class="info-img">
                <img src="//qzonestyle.gtimg.cn/qz-proj/weishi-pc/img/qrcode.png" alt="微视手机版">
              </div>
              <div class="info-txt">
                <p>手机应用下载</p>
              </div>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(dom.str2dom(qrcodeDomStr));
    }
    if (!this.hasBindQRCodeEvent) {
      this.hasBindQRCodeEvent = true;
      document.querySelector('.j-icon-close').addEventListener('click', () => {
        document.querySelectorAll('.j-pop').forEach(item => (item.style.display = 'none'));
      });
    }
    document.querySelectorAll('.j-pop').forEach(item => (item.style.display = 'block'));
  }

  /**
   * 对于一些无法跳转的客户端，给一个打开系统浏览器的提示浮层
   * @param {Function} callback
   */
  initSchemeTips(callback) {
    load.loadCss('//qzonestyle.gtimg.cn/qz-proj/weishi-mobile/mod-tip-mask.css', () => {
      if (document.querySelectorAll('.j-mod-tip-mask').length <= 0) {
        const html = `
          <div class="mod-tip-mask j-mod-tip-mask" style="display:none;">
            <div class="arrow"></div>
            <p class="tip">请点击右上角，选择“在${browser.platform === 'ios' ? 'Safari' : '浏览器'}中打开”</p>
          </div>`;
        document.body.appendChild(dom.str2dom(html));
      }
      if (!this.hasBindMaskCloseEvent) {
        this.hasBindMaskCloseEvent = true;
        document.querySelector('.j-mod-tip-mask').addEventListener('click', (e) => {
          // hide
          console.log(e);
        });
      }

      if (callback) {
        callback();
      }
    });
  }

  /**
   * 展示不能跳转 schema 提示
   * @param {String} schema
   */
  showSchemeTip(schema) {
    window.location.hash = `#scheme=${encodeURIComponent(schema)}`;
    this.initSchemeTips(() => {
      const box = document.querySelector('.j-mod-tip-mask');
      if (box) {
        box.style.display = 'block';
      }
    });
  }
}

export default new ComUI();
